import { Button, CardTitle } from '@client/toolkit';
import { useTranslation } from 'react-i18next';
import { FaChevronDown } from 'react-icons/fa';
import { useState } from 'react';
import { PackageType, SpaceHierarchyReadModel } from '@client/api';
import { SpaceHierarchySelector } from '../../../../components/space-hierarchy-selector';

export const SpaceHierarchySelectionModal = ({
  onChange,
  selectedSpaces,
  packageFilter,
  showLabel = true,
  selectMultipleSpaces = true,
}: {
  onChange: (spaces: SpaceHierarchyReadModel[]) => void;
  selectedSpaces: SpaceHierarchyReadModel[];
  packageFilter?: PackageType;
  selectMultipleSpaces?: boolean;
  showLabel?: boolean;
}) => {
  const { t: tCommon } = useTranslation('common');
  const { t: tGlobal } = useTranslation('global');
  const [openModal, setOpenModal] = useState(false);

  return (
    <div className="flex flex-col gap-2">
      {showLabel && (
        <CardTitle className="flex-1" variant="dense">
          {tGlobal('entity.space', { context: selectMultipleSpaces ? 'plural' : 'singular' })}
        </CardTitle>
      )}
      <Button
        color="primary-invert"
        size="sm"
        className="w-full justify-between text-white h-[40px]"
        onClick={() => setOpenModal(true)}
        endIcon={<FaChevronDown />}
      >
        {selectedSpaces.length > 0
          ? `${selectedSpaces.length} ${tGlobal('entity.space', {
              context: selectedSpaces.length === 1 ? 'singular' : 'plural',
            }).toLowerCase()}`
          : tCommon('selectEntity', {
              entity: tGlobal('entity.space', { context: selectMultipleSpaces ? 'plural' : 'singular' }).toLowerCase(),
            })}
      </Button>
      <SpaceHierarchySelector
        open={openModal}
        selected={selectedSpaces}
        onClose={() => setOpenModal(false)}
        onSubmit={(value: SpaceHierarchyReadModel[]) => {
          setOpenModal(false);
          onChange(value);
        }}
        packageFilter={packageFilter}
        allowMultiSelect={selectMultipleSpaces}
        showBuildingSelector={true}
      />
    </div>
  );
};
